module.exports = __webpack_public_path__ + "img/fdx_180410.db073ca.7b52399d.svg";